import {debounce} from '../components/custom-lodash';
import ConstructorIOSearchSuggestions from '../constructor-io/search-suggestions';
import SearchSuggest from '../spa/components/search-suggest/search-suggestions';
import util from '../utils/util';

let constructorIOSearchSuggestions = null;
if (window.CONSTRUCTOR_SEARCH_SUGGEST_ENABLED && window.CONSTRUCTOR_API_KEY !== null) {
    constructorIOSearchSuggestions = new ConstructorIOSearchSuggestions();
}

let currentQuery = null;
let lastQuery = null;
let runningQuery = null;
let listTotal = -1;
let listCurrent = -1;
let $resultsContainer;
let $faqResultsContainer;
let $focusedSearchForm;
const delay = 30;
const debounceDelay = 400;
const $headerNavTablet = $('.header-navigation-tablet');
const $headerNavMobile = $('.header-navigation-mobile');
const $headerNavDesktop = $('.header-navigation-desktop');
const $body = $('body');

/**
 * @function
 * @description Handles keyboard's arrow keys
 *
 * @param {number} keyCode Code of an arrow key to be handled
 * @returns {boolean|void} false if key is not handled
 */
const handleArrowKeys = keyCode => {
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = listCurrent <= 0 ? listTotal - 1 : listCurrent - 1;
            break;
        case 40:
            // keyDown
            listCurrent = listCurrent >= listTotal - 1 ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
    $('input[name="q"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
    return true;
};

export default {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');

        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.focus(function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>')
                    .attr('class', 'search-suggestions')
                    .attr('role', 'dialog')
                    .attr('aria-modal', 'true')
                    .appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
            $headerNavTablet.addClass('active');
            $headerNavMobile.addClass('active');
            $headerNavDesktop.addClass('active');
        });

        $searchContainer
            .on('click', '.search-reset', function (e) {
                e.preventDefault();
                $searchField.val('').focus();
            })
            .on('touchstart', '.search-suggestions', function () {
                $searchField.blur();
            })
            .on('scroll', function (e) {
                e.stopPropagation();
            });

        $('.header-logo-link, .skip-to-content').on('focusin', function () {
            $('.search-suggestions').fadeOut();
            $body.trigger('suggestions:hide');
        });

        // on key up listener
        $searchField.keyup(
            debounce(
                function (e) {
                    // get keyCode (window.event is for IE)
                    var keyCode = e.keyCode || window.event.keyCode;

                    // check and treat up and down arrows
                    if (handleArrowKeys(keyCode)) {
                        return;
                    }
                    // check for an ENTER or ESC
                    if (keyCode === 27) {
                        this.clearResults($resultsContainer || $faqResultsContainer);
                        return;
                    }

                    currentQuery = $(e.currentTarget).val().trim();

                    // no query currently running, init a update
                    if (runningQuery === null) {
                        runningQuery = currentQuery;
                        $focusedSearchForm = $searchForm;
                        setTimeout(this.suggest.bind(this), delay);
                    }
                }.bind(this),
                debounceDelay
            )
        );
    },
    faqInit: function (container, defaultValue) {
        var $faqSearchContainer = $(container);
        var $faqSearchForm = $faqSearchContainer.find('form[name="faqSimpleSearch"]');
        var $faqSearchField = $faqSearchForm.find('input[name="q"]');

        // disable browser auto complete
        $faqSearchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $faqSearchField.focus(function () {
            if (!$faqResultsContainer) {
                // create results container if needed
                $faqResultsContainer = $('<div/>')
                    .attr('class', 'faq-search-suggestions')
                    .attr('role', 'dialog')
                    .attr('aria-modal', 'true')
                    .appendTo($faqSearchContainer);
            }
            if ($faqSearchField.val() === defaultValue) {
                $faqSearchField.val('');
            }
        });

        $faqSearchContainer
            .on('click', '.faq-search-reset', function (e) {
                e.preventDefault();
                $faqSearchField.val('').focus();
            })
            .on('touchstart', '.faq-search-suggestions', function () {
                $faqSearchField.blur();
            })
            .on('scroll', function (e) {
                e.stopPropagation();
            });

        $('.header-logo-link, .skip-to-content').on('focusin', function () {
            $('.faq-search-suggestions').fadeOut();
            $body.trigger('suggestions:hide');
        });

        // on key up listener
        $faqSearchField.keyup(
            debounce(
                function (e) {
                    // get keyCode (window.event is for IE)
                    var keyCode = e.keyCode || window.event.keyCode;

                    // check and treat up and down arrows
                    if (handleArrowKeys(keyCode)) {
                        return;
                    }
                    // check for an ENTER or ESC
                    if (keyCode === 27) {
                        this.clearResults($resultsContainer || $faqResultsContainer);
                        return;
                    }

                    currentQuery = $(e.currentTarget).val().trim();

                    // no query currently running, init a update
                    if (runningQuery === null) {
                        runningQuery = currentQuery;
                        $focusedSearchForm = $faqSearchForm;
                        setTimeout(this.suggest.bind(this), delay);
                    }
                }.bind(this),
                debounceDelay
            )
        );
    },
    /**
     * @function
     * @description trigger suggest action
     */
    suggest: async function () {
        let reqUrl;
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (runningQuery.length === 0) {
            this.clearResults($resultsContainer || $faqResultsContainer);
            runningQuery = null;
            return;
        }

        // if query is less than 3 characters, just return
        if (runningQuery.length < 3 && $focusedSearchForm.hasClass('faq-search-focused')) {
            runningQuery = null;
            return;
        }

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery) {
            runningQuery = null;
            return;
        }

        // build the request url
        if ($focusedSearchForm.hasClass('faq-search-focused')) {
            reqUrl = util.appendParamToURL(Urls.faqSearchSuggest, 'q', runningQuery);
        } else if ($focusedSearchForm.hasClass('header-search-focused')) {
            reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);
        }

        if (
            window.CONSTRUCTOR_SEARCH_SUGGEST_ENABLED &&
            constructorIOSearchSuggestions !== null &&
            !$focusedSearchForm.hasClass('faq-search-focused')
        ) {
            const {products, terms} = await constructorIOSearchSuggestions.getSuggestions(runningQuery);

            if (products !== null) {
                const searchURL = util.appendParamToURL(window.Urls.search, 'q', runningQuery);
                const suggestionHTML = SearchSuggest({products, terms, searchURL});
                $resultsContainer.html(suggestionHTML);
                $resultsContainer.fadeIn(200);
            } else {
                this.clearResults($resultsContainer || $faqResultsContainer);
            }
            this.postSearchActions();
        } else {
            // execute server call
            $.get(
                reqUrl,
                function (data) {
                    var suggestionHTML = data;
                    var ansLength = suggestionHTML.trim().length;

                    // if there are results populate the results div
                    if (ansLength === 0) {
                        this.clearResults($resultsContainer || $faqResultsContainer);
                    } else {
                        // update the results div
                        if ($focusedSearchForm.hasClass('faq-search-focused')) {
                            $faqResultsContainer.html(suggestionHTML);
                            $faqResultsContainer.fadeIn(200);
                        } else if ($focusedSearchForm.hasClass('header-search-focused')) {
                            $resultsContainer.html(suggestionHTML);
                            $resultsContainer.fadeIn(200);
                        }

                        if ($resultsContainer.find('.search-suggestion-wrapper').length) {
                            $body.trigger('suggestions:show');
                        }
                    }

                    this.postSearchActions();
                }.bind(this)
            );
        }
    },
    /**
     * @function
     * @description
     */
    clearResults: function (resultsContainer) {
        if (!resultsContainer) {
            return;
        }

        resultsContainer.fadeOut(200, function () {
            resultsContainer.empty();
        });

        $body.trigger('suggestions:hide');
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        // hide left panel if there is only a matching suggested custom phrase
        if (
            $('.search-suggestion-left-panel-hit').length === 1 &&
            $('.search-phrase-suggestion a')
                .text()
                .replace(/(^[\s]+|[\s]+$)/g, '')
                .toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()
        ) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    },
    /**
     *  Handles common post-search steps
     */
    postSearchActions: function () {
        // record the query that has been executed
        lastQuery = runningQuery;
        // reset currently running query
        runningQuery = null;

        // check for another required update (if current search phrase is different from just executed call)
        if (currentQuery !== lastQuery) {
            // ... and execute immediately if search has changed while this server call was in transit
            runningQuery = currentQuery;
            setTimeout(this.suggest.bind(this), delay);
        }
        this.hideLeftPanel();
    }
};
